import { BarChartColorPalette } from "models/propTypes/chartProps";
import chartStripes from "images/chart-stripes.svg";
import variables from "theme/styles/_variables.module.scss";

/* ***** Id constants ***** */
export const LegendIdPrefix = "legend_";
export const ContainerIdPrefix = "container_";
export const DoughnutChartIdPrefix = "doughnut_";
export const BarChartIdPrefix = "bar_";
export const LineChartIdPrefix = "line_";
export const TreeChartIdPrefix = "tree_";

export const DashboardMainChartContainerId = "dashboard_main_chart_container";

/* ***** Tooltips constants ***** */
export const TooltipBackgroundColor = variables.darkBlue;
export const TooltipTitleFontColor = variables.white;
export const TooltipBodyFontColor = variables.blueV4;
export const TooltipTitleFontSize = 12;
export const TooltipBodyFontSize = 10;

/* ***** Color schemes ***** */

export const ChartsDefaultColorPalette = [
  variables.blueV2,
  variables.darkBlueV2,
  variables.red,
  variables.lightYellowV4,
  variables.yellow,
  variables.yellowV2,
  variables.darkRed,
  variables.lightRedV4,
  variables.lightBlueV2,
];

// Doughnut chart colors
export const MiddleTextFontColor = variables.darkBlue;
export const DefaultPointerColor = variables.blackTransparentV3;

export const DoughnutChartStatusColorPalette = [
  variables.yellowV4,
  variables.orangeV2,
  variables.darkBlue,
  variables.green,
  variables.lightGrayV2,
];
export const DoughnutChartRatingColorPalette = [variables.green, variables.yellowV4, variables.red];
export const DoughnutChartEmptyColorPalette = [variables.lightGrayV2];

export const DoughnutChartInvoiceStatusColorPalette = [
  variables.darkBlue,
  variables.redV2,
  variables.redV4,
  variables.darkRedV3,
  variables.lightGrayV2,
  variables.green,
];

export const DoughnutChartIncomingInvoiceStatusColorPalette = [
  variables.yellowV4,
  variables.orangeV2,
  variables.darkBlue,
  variables.green,
  variables.lightGrayV2,
  variables.darkBlue,
];

// Bar chart colors
export const BarLegendFontColor = variables.gray;
export const BarGridLinesColor = variables.lightGray;
export const BarAxisColor = variables.lightGrayV2;
export const BarBackdropColor = variables.lightGray;

export const BarChartDefaultColorPalette: BarChartColorPalette[] = [
  { backgroundColor: variables.blueV2, borderColor: variables.blueV2 },
  { backgroundColor: variables.blueV6, borderColor: variables.blueV5 },
  { borderColor: variables.blueV5, backgroundImageSource: chartStripes },
];

// Tree chart colors
export const NodeStrokeColor = variables.black;
export const NodeFillColor = variables.darkGray;

/* ***** Other constants ***** */

export const DefaultDataUnit = "kr";
export const DefaultDataUnitThousend = "tkr";
export const DefaultDataUnitMillion = "mnkr";

export const ChartKeys = {
  IncomingInvoiceAmountByState: "II1",
  IncomingInvoiceAmountByDueInDays: "II2",
  ArticleComparableMonth: "AR1",
  ArticleComparableAccountLine: "AR2",
  ArticleCustomerSummary: "AR3",
  ArticleStatisticSummary: "AR4",
  ArticlesSalesSummary: "AR5",
  ArticlesSalesSummaryOverTimeLine: "AR6",
  InvoicedAmount: "CI1",
  InvoiceStatusDistribution: "CI2",
  AccumulatedInvoicedAmount: "CI3",
  SupplierInvoiceTotalByMonth: "SI1",
  SupplierInvoiceTotalAccumulated: "SI2",
  SupplierInvoiceTotal12Months: "SI3",
  SuppliersTop3Comparable: "SS1",
  NumOfInvoicedSuppliersComparable: "SS2",
  ReceiptCategoriesDistribution: "RC1",
  ReceiptPurchasesPerMonth: "RC2",
  ReceiptPurchasesPerMonthAccumulated: "RC3",
  CustomerRatingSummary: "CR1",
  CustomerHighestInvoiceTotal: "CR2",
  OperatingProfitFiscalYear: "R3",
  AccumulatedOperatingProfit: "R4",
  OperatingProfitPerMonth: "R5",
  SalesCurrentMonth: "S1",
  QuotesStatusDistribution: "QT1",
  QuotesComparableMonthWidget: "QT2",
  QuotesComparableAccLineWidget: "QT3",
  DashboardSalesComparableBarWidget: "DS1",
  DashboardSalesAccLineWidget: "DS2",
  DashboardCostsComparableWidget: "DC1",
  DashboardCostsAccLineWidget: "DC2",
  DashboardGrossMarginComparableWidget: "DG1",
  DashboardGrossMarginAccLineWidget: "DG2",
  DashboardResultComparableWidget: "DR1",
  DashboardResultAccLineWidget: "DR2",
  DashboardCostsAccountSummeryPieWidget: "DC3",
  BalanceReportAssetsSummaryPieWidget: "BR1",
  BalanceReportDebtSummaryPieWidget: "BR2",
  BalanceReportAssetsSummaryLineWidget: "BR3",
  BalanceReportDebtSummaryLineWidget: "BR4",
  OwnershipStructureWidget: "OS1",
  WintSalaryDeviationDistributionChart: "WS1",
  WintSalaryDeviationVariationChart: "WS2",
  WintSalaryTotalCostPerMonth: "WSO1",
  WintSalaryTotalCostPerMonthAccumulated: "WSO2",
  WintSalaryGrossSalaryPerMonthAccumulated: "WSO3",
};
